import de from './de.json';
import nl from './nl.json';
import es from './es.json';
import fr from './fr.json';
import pt_BR from './pt-BR.json';

export default {
    de,
    nl,
    es,
    fr,
    'pt-BR': pt_BR,
};
